import DecryptPaymentPage from "./DecryptPaymentPage";

export default DecryptPaymentPage;
